import '../sass/Name.scss'
import wallpaper from '../assets/wallpaper.webp'

function Name() {
    return (
        <div className='name' id='name'>
            <img src={wallpaper} alt="" aria-hidden="true" className="name-wallpaper" fetchpriority="high" />
            <div className='intro'>
                <h1 className='green'>LILIAN<br/>SCHOTT</h1>
            </div>
            <h2>DÉVELOPPEUR<br/>WEB FULL STACK</h2>
        </div>
    )
}
export default Name
